import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20fashion%20retail%20atmosphere%20with%20soft%20diffused%20lighting%2C%20cream%20and%20sand%20tones%2C%20elegant%20textile%20display%20with%20cashmere%20and%20linen%20fabrics%2C%20lifestyle%20editorial%20photography%2C%20clean%20sophisticated%20aesthetic%2C%20gentle%20bokeh%20background&width=1600&height=900&seq=cta-bg-fashion-lifestyle&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-wider mb-4">
          {t("cta.title")}
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-md mb-6">
          {t("cta.subtitle1")}
          <br />
          {t("cta.subtitle2")}
        </p>
        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
        >
          <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </div>
          {t("cta.button")}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </section>
  );
}